import React, { Component } from 'react';
import './App.css';
import ColorSetter from './components/ColorSetter/ColorSetter.jsx';
import CustomColors from './components/CustomColors/CustomColors.jsx';
import AdminDashboard from './components/AdminDashboard/AdminDashboard.jsx';

class App extends Component {
  state = {
    stuff: "stuff",
    colors: {
      mainColor: 'rgba(250, 3, 188, .5)',
      accentColor: 'rgba(47, 204, 170, 1) ',
      mainTextColor: 'rgba(192, 192, 192, 1)',
      titleColor: 'rgba(138, 139, 139, 1)',
      backgroundColor: 'rgba(255, 255, 255, 1)',
      sideNavColor: 'rgba(33, 33, 55, 1)',
      sideNavTextColor: 'rgba(255, 255, 255, 1)',
      headerColor: 'rgba(99, 98, 98, 1)',
      headerTextColor: 'rgba(255, 255, 255, 1)',
      panelColor: 'rgba(230, 225, 225, 1)'
    },
    backgroundImage: ''
  }

  // @ get string info
  changeColorHandler = (event,name) => {
    // console.log(event);
    // console.log(name);
    // console.log(event.target.value);
    
    // put the color into a variable
    const temp_color = event.target.value;

    // copy state
    const colors = {...this.state.colors}
    colors[name] = temp_color;
    
    // update state
    this.setState({
      colors: colors});
  }
  
  // @ set new back ground
  setBackgroundHandler = (event) => {
    // console.log(event.target.value);
    // put the string into a variable
    const temp_string = event.target.value;

    // update state
    this.setState({backgroundImage: temp_string});
  }


  handleChangeComplete = (color, name) => {
    // console.log(color.hex);
    // console.log(color.rgb);
    // console.log(color);
    // console.log(name);

    // put the color into a variable
    // const temp_color = color.hex;
    // create the RGB value
    const temp_color = "rgba(" + color.rgb.r + ", " + color.rgb.g + ", " + color.rgb.b + ", " + color.rgb.a + ")";
    // console.log(temp_color);

    // copy state
    const colors = {...this.state.colors}
    colors[name] = temp_color;
    
    // update state
    this.setState({colors: colors});
  };

  render() {
    return (
      <ColorSetter colors={this.state.colors}>
        <div className="App">
          <AdminDashboard backgroundImage={this.state.backgroundImage}/>
          {/* <div className='mainColor ex'></div>
          <div className='accentColor ex'></div>
          <div className='mainTextColor ex'></div>
          <div className='titleColor ex'></div>
          <div className='backgroundColor ex'></div> */}
          {/* <div className='headerColor ex'></div>
          <div className='sideNavColor ex'></div> */}
          {/* <div className='headerTextColor ex'></div> */}
          <CustomColors data={this.state.colors} onChange={this.handleChangeComplete} backgroundImage={this.setBackgroundHandler}/>
        </div>
      </ColorSetter>
    );
  }
}

export default App;
